import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
 private modalState = new BehaviorSubject<string | null>(null);
  modalState$ = this.modalState.asObservable();

  openModal(popupName: string, row: any|null = null) {
    this.modalState.next(popupName);
  }

  closeModal() {
    this.modalState.next(null);
  }
}
